var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { action: "#" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit()
        },
      },
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c("h3", { staticClass: "h5 font-weight-bold mb-3" }, [
            _vm._v("Žadatel"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.companyName,
                    expression: "values.companyName",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "companyName",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.companyName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.values,
                      "companyName",
                      $event.target.value.trim()
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(0),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.name,
                    expression: "values.name",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "name",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.values, "name", $event.target.value.trim())
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(1),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.address,
                    expression: "values.address",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "Address",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.address },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.values, "address", $event.target.value.trim())
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(2),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.companyID,
                    expression: "values.companyID",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "companyID",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.companyID },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.values,
                      "companyID",
                      $event.target.value.trim()
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(3),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.phone,
                    expression: "values.phone",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "Phone",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.values, "phone", $event.target.value.trim())
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(4),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.email,
                    expression: "values.email",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "email",
                  id: "Email",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.values, "email", $event.target.value.trim())
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(5),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "custom-control custom-radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.values.applicationType,
                    expression: "values.applicationType",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: {
                  type: "radio",
                  name: "applicationType",
                  value: "internal",
                  id: "applicationType--internal",
                  required: "",
                },
                domProps: {
                  checked: _vm._q(_vm.values.applicationType, "internal"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.values, "applicationType", "internal")
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "applicationType--internal" },
                },
                [_vm._v("\n            Interní\n          ")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "custom-control custom-radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.values.applicationType,
                    expression: "values.applicationType",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: {
                  type: "radio",
                  name: "applicationType",
                  value: "external",
                  id: "applicationType--external",
                  required: "",
                },
                domProps: {
                  checked: _vm._q(_vm.values.applicationType, "external"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.values, "applicationType", "external")
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "applicationType--external" },
                },
                [
                  _vm._v(
                    "\n            Externí (v rámci skupiny EUC a.s.)\n          "
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("h3", { staticClass: "h5 font-weight-bold mb-3" }, [
            _vm._v("Způsob financování"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.completeAmountNeeded,
                    expression: "values.completeAmountNeeded",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "completeAmountNeeded",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.completeAmountNeeded },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.values,
                      "completeAmountNeeded",
                      $event.target.value.trim()
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(6),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.ownCapital,
                    expression: "values.ownCapital",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "ownCapital",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.ownCapital },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.values,
                      "ownCapital",
                      $event.target.value.trim()
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(7),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.requestedAmount,
                    expression: "values.requestedAmount",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "requestedAmount",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.requestedAmount },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.values,
                      "requestedAmount",
                      $event.target.value.trim()
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(8),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "custom-control custom-checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.values.foreignResources,
                    expression: "values.foreignResources",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "foreignResources" },
                domProps: {
                  checked: Array.isArray(_vm.values.foreignResources)
                    ? _vm._i(_vm.values.foreignResources, null) > -1
                    : _vm.values.foreignResources,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.values.foreignResources,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.values,
                            "foreignResources",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.values,
                            "foreignResources",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.values, "foreignResources", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(9),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.values.foreignResources,
                  expression: "values.foreignResources",
                },
              ],
              staticClass: "form-group",
            },
            [
              _c("div", { staticClass: "mb-2 custom-placeholder" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.values.foreignResourcesDescription,
                      expression: "values.foreignResourcesDescription",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    id: "foreignResourcesDescription",
                    placeholder: " ",
                    required: _vm.values.foreignResources,
                  },
                  domProps: { value: _vm.values.foreignResourcesDescription },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.values,
                        "foreignResourcesDescription",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _vm._v(" "),
                _vm._m(10),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group mb-4" }, [
            _c("div", { staticClass: "custom-file" }, [
              _c("input", {
                staticClass: "custom-file-input",
                attrs: { type: "file", id: "attachments", multiple: "" },
                on: { change: _vm.handleFiles },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-file-label text-truncate pr-5",
                  attrs: { for: "attachments" },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.attachmentsLabel) +
                      "\n          "
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("h3", { staticClass: "h6 mb-3" }, [
            _vm._v(
              "\n        Doporučení osob, které mohou podat reference k žadateli či jeho\n        projektu, kontakt na tyto osoby.\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.recommendation,
                    expression: "values.recommendation",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "recommendation", rows: "4", placeholder: " " },
                domProps: { value: _vm.values.recommendation },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.values,
                      "recommendation",
                      $event.target.value.trim()
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(11),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(12),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c("h3", { staticClass: "h5 font-weight-bold mb-3" }, [
            _vm._v("Předmět žádosti"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.message,
                    expression: "values.message",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  id: "message",
                  rows: "4",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.message },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.values, "message", $event.target.value.trim())
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(13),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "custom-control custom-checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.values.gdprAgreement,
                    expression: "values.gdprAgreement",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "GdprAgreement", required: "" },
                domProps: {
                  checked: Array.isArray(_vm.values.gdprAgreement)
                    ? _vm._i(_vm.values.gdprAgreement, null) > -1
                    : _vm.values.gdprAgreement,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.values.gdprAgreement,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.values,
                            "gdprAgreement",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.values,
                            "gdprAgreement",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.values, "gdprAgreement", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(14),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "custom-control custom-checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.values.marketingAgreement,
                    expression: "values.marketingAgreement",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "MarketingAgreement" },
                domProps: {
                  checked: Array.isArray(_vm.values.marketingAgreement)
                    ? _vm._i(_vm.values.marketingAgreement, null) > -1
                    : _vm.values.marketingAgreement,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.values.marketingAgreement,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.values,
                            "marketingAgreement",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.values,
                            "marketingAgreement",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.values, "marketingAgreement", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(15),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "custom-control custom-checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.values.truthfulStatement,
                    expression: "values.truthfulStatement",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: {
                  type: "checkbox",
                  id: "truthfulStatement",
                  required: "",
                },
                domProps: {
                  checked: Array.isArray(_vm.values.truthfulStatement)
                    ? _vm._i(_vm.values.truthfulStatement, null) > -1
                    : _vm.values.truthfulStatement,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.values.truthfulStatement,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.values,
                            "truthfulStatement",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.values,
                            "truthfulStatement",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.values, "truthfulStatement", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "truthfulStatement" },
                },
                [
                  _vm._v(
                    '\n            Prohlašuji, že všechny údaje v tomto dotazníku a v přílohách jsou\n            pravdivé. Souhlasím tím, že Nadační fond EUC „Elucidate" si může\n            ověřit na příslušném personálním oddělení mého zaměstnavatele\n            skutečnosti o formě a rozsahu mého pracovního poměru.\n          '
                  ),
                ]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _vm.error.showing
            ? _c("div", { staticClass: "alert alert-secondary mb-4" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.error.text
                        ? _vm.error.text
                        : "Něco se nezdařilo, zkuste to prosím později"
                    ) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "submit", disabled: _vm.isSending },
              },
              [_vm._v("\n          " + _vm._s(_vm.buttonText) + "\n        ")]
            ),
          ]),
          _vm._v(" "),
          _vm._m(16),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "companyName" } },
      [_c("span", [_vm._v(" Název žadatele ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "name" } },
      [_c("span", [_vm._v(" Jméno a příjmení zodpovědné osoby ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "Address" } },
      [_c("span", [_vm._v(" Adresa ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "companyID" } },
      [_c("span", [_vm._v(" IČO ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "Phone" } },
      [_c("span", [_vm._v(" Kontaktní telefon ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "Email" } },
      [_c("span", [_vm._v(" E-mail ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "completeAmountNeeded" } },
      [_c("span", [_vm._v(" Potřebná částka celkem ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "ownCapital" } },
      [_c("span", [_vm._v(" Vlastní zdroje ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "requestedAmount" } },
      [
        _c("span", [
          _vm._v(
            "\n              Částka požadovaná od Nadačního fondu EUC „Elucidate“\n            "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      {
        staticClass: "custom-control-label",
        attrs: { for: "foreignResources" },
      },
      [
        _vm._v("\n            Cizí zdroje\n            "),
        _c("span", { staticClass: "small" }, [
          _vm._v(
            "(např. dotace, nadační příspěvky od jiných nadací a nadačních\n              fondů apod.)"
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      {
        staticClass: "label-floating",
        attrs: { for: "foreignResourcesDescription" },
      },
      [_c("span", [_vm._v(" Jaké ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "recommendation" } },
      [
        _c("span", [
          _vm._v(
            "\n              Doporučení osob, které mohou podat reference k žadateli či jeho\n              projektu, kontakt na tyto osoby."
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "col-lg-5 mb-4 pt-lg-4 mt-lg-2 text-primary order-first order-lg-0",
      },
      [
        _c("p", [
          _vm._v(
            "\n        Řádné vyplnění této žádosti jsou nezbytnými předpoklady, aby Nadační\n        fond EUC „Elucidate“ mohl zvážit možnost uzavření smlouvy o poskytnutí\n        nadačního příspěvku s žadatelem.\n      "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "message" } },
      [_c("span", [_vm._v(" Předmět žádosti ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "custom-control-label", attrs: { for: "GdprAgreement" } },
      [
        _vm._v("\n            Seznámil/a jsem se s\n            "),
        _c(
          "a",
          {
            attrs: { href: "/o-nas/ochrana-osobnich-udaju/", target: "_blank" },
          },
          [_vm._v("Podmínkami ochrany osobních údajů.")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      {
        staticClass: "custom-control-label",
        attrs: { for: "MarketingAgreement" },
      },
      [
        _vm._v(
          "\n            Souhlasím s využitím osobních údajů za účelem\n            "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "/files/souhlas-se-zpracovanim-ou-zpetna-vazba.pdf",
              target: "_blank",
            },
          },
          [_vm._v("získání zpětné vazby")]
        ),
        _vm._v("\n            a se\n            "),
        _c(
          "a",
          {
            attrs: {
              href: "/files/souhlas-se-zpracovanim-ou-marketing.pdf",
              target: "_blank",
            },
          },
          [_vm._v("zasíláním marketingových sdělení")]
        ),
        _vm._v(".\n          "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "mt-3 text-gray-lighter font-size-small" },
      [
        _c("p", [
          _vm._v(
            "\n          Tato stránka je chráněna systémem reCAPTCHA od Google s\n          "
          ),
          _c(
            "a",
            {
              staticClass: "text-gray-lighter",
              attrs: {
                href: "https://policies.google.com/privacy",
                target: "_blank",
              },
            },
            [_c("u", [_vm._v("ochranou soukromí")])]
          ),
          _vm._v("\n          a\n          "),
          _c(
            "a",
            {
              staticClass: "text-gray-lighter",
              attrs: {
                href: "https://policies.google.com/terms",
                target: "_blank",
              },
            },
            [_c("u", [_vm._v("podmínkami používání")])]
          ),
          _vm._v(".\n        "),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }